import { useState } from "react";
import { Eye, EyeOff, LockKeyhole, Mail, UserRound } from "lucide-react";
import { AnimatedInput } from "@/components/ui/animated-input";

export default function LoginFields({ username, onUsernameChange, password, onPasswordChange, email = false, loading, usernameTestId, passwordTestId }) {
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = (key, input) => {
    const message = input.validity.valueMissing
      ? (key === "password" ? "Informe sua senha." : email ? "Informe seu e-mail." : "Informe seu login.")
      : input.validity.typeMismatch ? "Informe um e-mail válido." : "";
    setErrors((current) => ({ ...current, [key]: message }));
  };

  return (
    <div className="space-y-3">
      <AnimatedInput
        label={email ? "E-mail" : "Login"}
        name={email ? "email" : "login"}
        type={email ? "email" : "text"}
        autoComplete="username"
        autoCapitalize="none"
        spellCheck={false}
        required
        disabled={loading}
        value={username}
        onChange={(value) => {
          onUsernameChange(value);
          setErrors((current) => ({ ...current, username: "" }));
        }}
        onBlur={(event) => validate("username", event.target)}
        onInvalid={(event) => validate("username", event.target)}
        error={errors.username}
        reserveErrorLine
        leftIcon={email ? <Mail className="h-4 w-4" /> : <UserRound className="h-4 w-4" />}
        placeholder={email ? "Seu e-mail cadastrado" : "Seu login GSX"}
        data-testid={usernameTestId}
      />
      <AnimatedInput
        label="Senha"
        name="password"
        type={showPassword ? "text" : "password"}
        autoComplete="current-password"
        required
        disabled={loading}
        value={password}
        onChange={(value) => {
          onPasswordChange(value);
          setErrors((current) => ({ ...current, password: "" }));
        }}
        onBlur={(event) => validate("password", event.target)}
        onInvalid={(event) => validate("password", event.target)}
        error={errors.password}
        reserveErrorLine
        leftIcon={<LockKeyhole className="h-4 w-4" />}
        placeholder="Digite sua senha"
        data-testid={passwordTestId}
        endAdornment={
          <button
            type="button"
            disabled={loading}
            onClick={() => setShowPassword((current) => !current)}
            aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
            aria-pressed={showPassword}
            className="mr-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-amber-400/10 hover:text-amber-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/50 disabled:opacity-50"
          >
            {showPassword ? <EyeOff className="h-4 w-4" aria-hidden="true" /> : <Eye className="h-4 w-4" aria-hidden="true" />}
          </button>
        }
      />
    </div>
  );
}
